namespace TabAurous.HR {
    export interface SalaryComponentForm {
        Code: Serenity.StringEditor;
        Type: Serenity.EnumEditor;
        Narration: Serenity.StringEditor;
    }

    export class SalaryComponentForm extends Serenity.PrefixedContext {
        static formKey = 'HR.SalaryComponent';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SalaryComponentForm.init)  {
                SalaryComponentForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;

                Q.initFormType(SalaryComponentForm, [
                    'Code', w0,
                    'Type', w1,
                    'Narration', w0
                ]);
            }
        }
    }
}
